// components/Testimonials.js
import React from "react";
import "./Testimonials.css";

const DEFAULT_IMAGE = "https://via.placeholder.com/80x80.png?text=User";

const Testimonials = () => {
  const testimonials = [
    {
      text: "Finding the right office for my family felt overwhelming, but this portal made the entire process smooth. We found a spacious 3000 sqft in just 4 days!",
      author: "Rohit Deshmukh",
      position: "Office Buyer, Pune",
      image: "https://randomuser.me/api/portraits/men/43.jpg",
    },
    {
      text: "I was searching for a rental near my workplace and the property consultants helped me with multiple verified listings. No hidden charges at all! Highly trusted.",
      author: "Shruti Iyer",
      position: "Tenant, Mumbai",
      image: "https://randomuser.me/api/portraits/women/28.jpg",
    },
    {
      text: "Excellent service! They helped me lease out my commercial property to a reputed brand within a month. Transparency and professionalism at its best.",
      author: "Mahesh Patil",
      position: "Property Owner, Nashik",
      image: "https://randomuser.me/api/portraits/men/75.jpg",
    },
  ];

  return (
    <section className="testimonials">
      <div className="container">
        <p className="testimonial-subtitle">TESTIMONIALS</p>
        <h2 className="testimonial-title">What Our Clients Say</h2>

        <div className="testimonial-grid">
          {testimonials.map((testimonial, index) => (
            <div key={index} className="testimonial-card">
              <div className="quote-icon">❝</div>

              <p className="testimonial-text">{testimonial.text}</p>

              <div className="author-info">
                <img
                  src={testimonial.image || DEFAULT_IMAGE}
                  alt={testimonial.author}
                  className="author-img"
                  onError={(e) => {
                    e.target.onerror = null;
                    e.target.src = DEFAULT_IMAGE;
                  }}
                />
                <div>
                  <h4>{testimonial.author}</h4>
                  <p>{testimonial.position}</p>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Testimonials;
